import AirwayPanel from "./AirwayPanel.vue";
import AirwayButtons from "./AirwayButtons.vue";
import AirwayHeatmap from "./AirwayHeatmap.vue";
import AirwaySelectedSlice from "./AirwaySelectedSlice.vue";
import AirwayTopControls from "./AirwayTopControls.vue";

// import { getFullBox } from "@/components/occlusal/OcclusalTools.js";
import { drawRectangle } from "../draw/draw";
import { updateAppLayout } from "@/components/dicom/DicomManager.js";
import { mutationTypes } from "@/store/modules/dicom";
import { getFiguresForPlane } from "./AirwayColor.js";
import { DynamicTubeGeometry } from "@/components/geometry/DynamicTubeGeometry";

import store from "@/store";
import swal from "sweetalert";

const empty = Object.freeze([]);
const axialPlane = new THREE.Plane(new THREE.Vector3(0, -1, 0), 0);
const defaultLineColor = 0x000000;
const defLineRadius = 0.2;

let controlsInitialized = false;
let airwaysJsonObj = null;
let airwayFigures = null;
let airwaySliceMeshes = null;

let airway = null;
let sliceMesh = null;
let lineMesh = null;

let airwaysData = {
  isSquareOutline: true,
  isLineView: false,
  isCutSlice: false,
  total_volume: null,
  slices: [
    {
      name: "Minimal Area Slice",
      filename: "slice_min_area.png",
      imageUrl: "",
      jsonKey: "minimal_area_slice",
      selected: false,
      area: 0,
      ap_diameter: 0,
      rl_diameter: 0,
      slice_position: 0,
      position_text: null,
    },
    {
      name: "Minimal AP Slice",
      filename: "slice_min_ap.png",
      imageUrl: "",
      jsonKey: "minimal_ap_diam_slice",
      selected: false,
      area: 0,
      ap_diameter: 0,
      rl_diameter: 0,
      slice_position: 0,
      position_text: null,
    },
    {
      name: "Minimal Right-Left Slice",
      filename: "slice_min_rl.png",
      imageUrl: "",
      jsonKey: "minimal_rl_diam_slice",
      selected: false,
      area: 0,
      ap_diameter: 0,
      rl_diameter: 0,
      slice_position: 0,
      position_text: null,
    },
    {
      name: "Top Slice",
      filename: "slice_top.png",
      imageUrl: "",
      jsonKey: null,
      selected: false,
      area: 0,
      ap_diameter: 0,
      rl_diameter: 0,
      slice_position: 0.6,
      position_text: "0.6",
    },
    {
      name: "Bottom Slice",
      filename: "slice_bottom.png",
      imageUrl: "",
      jsonKey: null,
      selected: false,
      area: 0,
      ap_diameter: 0,
      rl_diameter: 0,
      slice_position: -0.6,
      position_text: null,
    },
  ],
  has_selected: false,
  selected_slice: {
    area: 0,
    ap_diameter: 0,
    rl_diameter: 0,
    slice_position: 0,
    position_text: null,
  },
};
let slicesLength = airwaysData.slices.length;
let bottomSlice = airwaysData.slices[slicesLength - 1];

let AirwayMode = {
  isActive: false,
  vcenter: null,
  dicomIncompatible: true,
  nonOcclusalable: true,
  enterMode: function () {
    enterAirwayMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveAirwayMode(false, saveActiveMode);
  },
  mouseUp: function (event) {
    return false;
  },
  mouseMove: function (event) {
    return false;
  },
  mouseClick: function (event) {
    return false;
  },
};

function enterAirwayMode() {
  console.log("enterAirwayMode");

  if (vueApp.isDicomOpen) {
    store.commit(mutationTypes.isAxialChange, false);
    store.commit(mutationTypes.isSaggitalChange, false);
    store.commit(mutationTypes.isCoronalChange, false);
    $(".dicom-container").css({ display: "none" });
    updateAppLayout();
  }

  if (vueApp.isSplitView) {
    vueApp.switchSplitView();
  }
  if (vueApp.isDicom3DView) {
    vueApp.switchDicom3dView();
  }

  airway = vueApp.airways && vueApp.airways.length ? vueApp.airways[0] : null;
  if (!airway) return;

  if (!airwaysJsonObj) {
    loadAirwaysJson(enterAirwayMode); //enterAirwayMode
    return;
  }

  initializeControls();
  vueApp.leaveModes(false, true);

  $(".teeth-list-ctrl").css("display", "none");
  $(".airway-mode-item").css("display", "block");

  vueApp.allItems.forEach((model) => {
    if (model != airway) {
      let mesh = viewer.get_model_mesh(model.id);
      mesh.visible = false;
      model.isHidden = true;
    }
  });

  let tmesh = viewer.get_model_mesh(airway.id);
  if (tmesh && tmesh.visible !== undefined) {
    tmesh.visible = false;
    if (!airway.defaultBox) {
      // let geometry = tmesh.geometry.clone();
      // geometry.applyMatrix4(tmesh.matrix);
      if (!tmesh.geometry.boundingBox) {
        tmesh.geometry.computeBoundingBox();
      }
      airway.defaultBox == offsetBox(tmesh.geometry.boundingBox);
      // geometry.dispose();
    }

    let airwayBox = airway.defaultBox;
    console.log("airwayBox", airwayBox);

    if (!bottomSlice.position_text) {
      bottomSlice.position_text = (airwayBox.size.y - 0.6).toFixed(2);
      airwaysData.slices.forEach((slice) => {
        if (!slice.slice_position) {
          slice.slice_position = airwayBox.size.y / 3;
          slice.position_text = slice.slice_position.toFixed(2);
        }
      });
    }

    vueApp.switchToDefaultView();
    let totalCount = vueApp.allItems.length;
    if (totalCount == 1 && vueApp.airways.length == 1) {
      $("#airwayExit").css({ display: "none" });
    } else {
      AirwayMode.vcenter = airwayBox.center;
      vueApp.lookAtPoint(AirwayMode.vcenter);
      viewer.camera.position.z = defaultZoom / 2 + airwayBox.center.z;
    }

    let selectedSlice = airwaysData.slices.find((s) => s.selected);
    if (!selectedSlice) selectedSlice = airwaysData.slices[0];

    selectSlice(selectedSlice);

    tmesh.visible = true;
  }

  vueApp.activeMode = AirwayMode;
  AirwayMode.isActive = true;
}

function loadAirwaysJson(callback) {
  var airwaysJson = `${vueApp.stlBaseUrl}/airways_volume_analysis.json`;
  fetch(airwaysJson)
    .then((response) => {
      response.text().then((text) => {
        try {
          airwaysJsonObj = JSON.parse(text);
          airwayFigures = {};
          airwaySliceMeshes = {};

          airwaysData.total_volume =
            (airwaysJsonObj.total_volume / 1000).toFixed(3) + " cc";
          console.log("airwaysJsonObj", airwaysJsonObj);

          airwaysData.slices.forEach((slice) => {
            if (slice.jsonKey && airwaysJsonObj[slice.jsonKey]) {
              slice.area = airwaysJsonObj[slice.jsonKey].area.toFixed(2);
              slice.ap_diameter =
                airwaysJsonObj[slice.jsonKey].ap_diameter.toFixed(2);
              slice.rl_diameter =
                airwaysJsonObj[slice.jsonKey].rl_diameter.toFixed(2);
              slice.slice_position =
                airwaysJsonObj[slice.jsonKey].slice_position;
              slice.position_text =
                airwaysJsonObj[slice.jsonKey].slice_position.toFixed(2);
            }
          });

          let airwayMesh = viewer.get_model_mesh(airway.id);
          let airwayBox = airway.defaultBox;
          airwaysData.slices.forEach((slice) => {
            let slicePosition =
              slice.slice_position > 0
                ? airwayBox.max.y - slice.slice_position + 0.1
                : airwayBox.min.y - slice.slice_position - 0.1;
            axialPlane.set(new THREE.Vector3(0, -1, 0), slicePosition);
            let figures = getFiguresForPlane(airwayMesh, axialPlane);
            airwayFigures[slice.filename] = figures;
            let lineMesh = getLineMeshFromFigures(figures, slicePosition);
            airwaySliceMeshes[slice.filename] = lineMesh;
            // viewer.scene.add(lineMesh);
          });
          console.log("airwayFigures", airwayFigures);

          if (callback) callback();
        } catch (e) {
          console.log(`Invalid JSON: ${airwaysJson}! Error: ${e}`);
          airwaysJsonObj = {};
          callback();
        }
      });
    })
    .catch((error) => {
      console.log(`Error response for ${airwaysJson}. Error: ${error}`);
      airwaysJsonObj = {};
      callback();
    });
}

function getLineMeshFromFigures(figures, slicePosition) {
  if (figures && slicePosition) {
    const group = new THREE.Group();
    for (const figure of figures) {
      let points = [];
      for (const vertice of figure.vertices) {
        let point = new THREE.Vector3(vertice.x, slicePosition, vertice.y);
        points.push(point);
      }
      if (points.length > 1) {
        let curve = createTubeCurve(points);
        group.add(curve);
      }
    }
    return group;
  }
}

function createTubeCurve(points) {
  if (!points || points.length < 2) {
    return;
  }

  let radius = defLineRadius;
  let material = new THREE.MeshBasicMaterial({ color: defaultLineColor });

  // let curve = new THREE.CurvePath();
  // for (let i = 1; i < points.length; i++) {
  //   const p0 = points[i - 1];
  //   const p1 = points[i];
  //   let lcurve = new THREE.LineCurve3(p0, p1);
  //   curve.add(lcurve);
  // }
  // curve.add(new THREE.LineCurve3(points[points.length - 1], points[0]));
  // let curve = new THREE.QuadraticBezierCurve3(points);
  // let tubeGeometry = new THREE.TubeGeometry(
  //   curve,
  //   10, // tubularSegments
  //   radius, // radius
  //   8, // radialSegments
  //   false // closed
  // );

  let tubeGeometry = DynamicTubeGeometry(
    radius,
    8,
    points.length * 2,
    false,
    false
  );
  tubeGeometry.update(radius, points);

  let line = new THREE.Mesh(tubeGeometry, material);
  line.name = "airway_line";
  return line;
}

function initializeControls() {
  if (!controlsInitialized) {
    airwaysData.slices.forEach((slice) => {
      slice.imageUrl = `${vueApp.stlBaseUrl}/${slice.filename}`;
    });

    console.log("airwaysData", airwaysData);

    var ctrls = [
      AirwayHeatmap,
      AirwaySelectedSlice,
      AirwayTopControls,
      AirwayPanel,
      AirwayButtons,
    ];
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: { airwaysData: airwaysData },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("stl_wrapper").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });
    controlsInitialized = true;
  }
}

function selectSlice(slice) {
  // console.log("selectSlice", slice);
  airwaysData.slices.forEach((item) => {
    item.selected = item === slice;
  });
  airwaysData.has_selected = true;
  airwaysData.selected_slice = slice;

  if (sliceMesh) viewer.scene.remove(sliceMesh);
  sliceMesh = null;
  if (lineMesh) viewer.scene.remove(lineMesh);
  lineMesh = null;

  updateSquareOutline();
  updateLineView();
  updateCutSlice();
}

function updateSquareOutline() {
  if (sliceMesh) viewer.scene.remove(sliceMesh);
  if (airwaysData.isSquareOutline) {
    if (sliceMesh) viewer.scene.add(sliceMesh);
    else if (airwaysData.selected_slice) {
      let slice = airwaysData.selected_slice;
      let airwayBox = airway.defaultBox;
      let dif = Math.max(airwayBox.size.x, airwayBox.size.z) / 2;
      let centerx = airwayBox.center.x;
      let centerz = airwayBox.center.z;

      let slicePosition =
        slice.slice_position > 0
          ? airwayBox.max.y - slice.slice_position
          : airwayBox.min.y - slice.slice_position;

      let slicePoints = [
        new THREE.Vector3(centerx - dif, slicePosition, centerz - dif),
        new THREE.Vector3(centerx + dif, slicePosition, centerz - dif),
        new THREE.Vector3(centerx + dif, slicePosition, centerz + dif),
        new THREE.Vector3(centerx - dif, slicePosition, centerz + dif),
      ];

      sliceMesh = drawRectangle(
        slicePoints,
        "black",
        new THREE.Vector3(0, 1, 0),
        true,
        true,
        null,
        0.7
      );
    }
  }
}

function updateLineView() {
  if (lineMesh) viewer.scene.remove(lineMesh);
  if (airwaysData.isLineView) {
    if (lineMesh) viewer.scene.add(lineMesh);
    else if (airwaysData.selected_slice) {
      let slice = airwaysData.selected_slice;
      lineMesh = airwaySliceMeshes[slice.filename];
      viewer.scene.add(lineMesh);
    }
  }
}

function updateCutSlice() {
  viewer.renderer.clippingPlanes = empty;
  if (airwaysData.isCutSlice && airwaysData.selected_slice) {
    let airwayBox = airway.defaultBox;
    let slice = airwaysData.selected_slice;
    let slicePosition = //airwayBox.max.y - slice.slice_position + 0.1;
      slice.slice_position > 0
        ? airwayBox.max.y - slice.slice_position + 0.1
        : airwayBox.min.y - slice.slice_position - 0.1;
    axialPlane.set(new THREE.Vector3(0, -1, 0), slicePosition);
    viewer.renderer.clippingPlanes = [axialPlane];
  }
}

function switchSquareOutline() {
  console.log("switchSquareOutline");
  airwaysData.isSquareOutline = !airwaysData.isSquareOutline;
  switchToggle("squareOutlineAirwayDiv", airwaysData.isSquareOutline);

  updateSquareOutline();
}

function switchLineView() {
  console.log("switchLineView");
  airwaysData.isLineView = !airwaysData.isLineView;
  switchToggle("lineViewAirwayDiv", airwaysData.isLineView);
  updateLineView();
}

function switchCutSlice() {
  console.log("switchCutSlice");
  airwaysData.isCutSlice = !airwaysData.isCutSlice;
  switchToggle("cutSliceAirwayDiv", airwaysData.isCutSlice);
  updateCutSlice();
}

function enlargeSlice(slice) {
  console.log("enlargeSlice", slice);
  if (slice) {
    let imgSrc = slice.imageUrl; //"images/set-color.gif";
    swal({
      title: slice.name,
      icon: imgSrc,
    });
    $(".swal-title").insertBefore($(".swal-icon"));

    var $closeButton = $(
      "<button type='button' class='close swal-close' aria-label='Close'><span aria-hidden='true'>&times;</span></button>"
    );
    $(".swal-modal").css("width", "620px");
    $(".swal-icon img").css("width", "610px");
    $(".swal-icon img").css("margin-bottom", "4px");
    $(".swal-title:first-child").css("margin-top", "17px");
    $(".swal-footer").css("display", "none");
    $(".swal-modal").append($closeButton);
    $(".swal-close").click(function () {
      swal.close();
    });
  }
}

function leaveAirwayMode() {
  $(".airway-mode-item").css("display", "none");
  $(".teeth-list-ctrl").css("display", "block");

  if (sliceMesh) viewer.scene.remove(sliceMesh);
  sliceMesh = null;
  if (lineMesh) viewer.scene.remove(lineMesh);
  lineMesh = null;

  vueApp.allItems.forEach(function (model) {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = model.isVisible;
    model.isHidden = false;
    // viewer.set_opacity(model.id, model.opacity);
  });

  vueApp.switchToDefaultView();

  //   let visibleBox = getFullBox(true);
  //   let vcenter = visibleBox.center;
  //   vueApp.lookAtPoint(vcenter);

  vueApp.activeMode = null;

  AirwayMode.isActive = false;
  vueApp.leaveModes(false, true);
  viewer.renderer.clippingPlanes = empty;
}

export {
  AirwayMode,
  enterAirwayMode,
  leaveAirwayMode,
  selectSlice,
  enlargeSlice,
  switchSquareOutline,
  switchLineView,
  switchCutSlice,
};
